import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { getLateLabelChargeAmount } from '../../util/payoutAdjustments';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Shows the seller a free-shipping label that was charged after the sale (kept in transaction
 * metadata, see util/payoutAdjustments.js).
 *
 * @component
 * @param {Object} props
 * @param {Object} props.transaction
 * @param {boolean} props.isProvider
 * @param {intlShape} props.intl
 * @returns {JSX.Element}
 */
const LineItemLateLabelChargeMaybe = props => {
  const { transaction, isProvider, intl } = props;
  const amount = isProvider ? getLateLabelChargeAmount(transaction) : 0;
  if (!amount) {
    return null;
  }
  const currency = transaction?.attributes?.payoutTotal?.currency || 'USD';
  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.freeShippingLabelCharge" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, new Money(-amount, currency))}</span>
    </div>
  );
};

export default LineItemLateLabelChargeMaybe;
